import React, { useMemo } from 'react'

import { isTurboView } from 'features/views/ListView/utils'

import { Text } from 'v2/ui'
import { CustomRadioGroup } from 'v2/ui/components/CustomRadio'

import { PERCENTAGE_FIELD_OPTIONS } from './percentAttributeEditorConstants'

type PercentAttributeEditorProps = {
    selectedOption?: string
    setState: (state: { [key: string]: any }) => void
    sendUpdate: any
    queuedChanges: any
    bgChecked?: string
    bgNotChecked?: string
    textColor?: string
    customRadioStyles?: React.CSSProperties
    display?: ListViewDisplay
}

export const PercentAttributeEditor = ({
    selectedOption,
    setState,
    sendUpdate,
    queuedChanges,
    bgChecked,
    bgNotChecked,
    textColor,
    customRadioStyles,
    display,
}: PercentAttributeEditorProps) => {
    const handlePercentageDisplayType = (value: 'percentNumber' | 'percentBar' | 'percentRing') => {
        setState((state: { [key: string]: any }) => {
            const newState = { ...state, percentageDisplay: value }
            // since sendUpdate is debounced, we want to batch up any changes together
            // to be processed/sent when the debounced function fires
            queuedChanges.current = { ...queuedChanges.current, percentageDisplay: value }
            sendUpdate()
            return newState
        })
    }

    const fieldOptions = useMemo(() => {
        if (isTurboView(display!)) {
            return PERCENTAGE_FIELD_OPTIONS.filter((option) => option.value !== 'percentRing')
        }

        return PERCENTAGE_FIELD_OPTIONS
    }, [display])

    return (
        <>
            <Text marginTop={1} marginBottom={1} variant="paletteSectionLabel">
                Show as
            </Text>
            <CustomRadioGroup
                selectedOption={selectedOption ?? 'percentNumber'}
                options={fieldOptions}
                onChange={handlePercentageDisplayType}
                bgChecked={bgChecked}
                bgNotChecked={bgNotChecked}
                textColor={textColor}
                customRadioStyles={customRadioStyles}
            />
        </>
    )
}
